import { useState } from "react";
import { Card, Form } from "react-bootstrap";
import ErrorComponent from "../../../Components/ErrorMessage";
import "./BooleanQuestion.css";
import { replacePlaceholder } from "../../../Utils/Utils";
function BooleanQuestionCard({
  question,
  handleChange,
  formValues,
  showError,
}) {
  const currentValue = formValues[question.tempId];
  const hasAnswer = currentValue !== undefined && currentValue !== null;
  const isMandatory = question.isMandatory;
  const questionText = replacePlaceholder(question.questionText, formValues);

  const handleLabelClick = (value) => {
    // Toggle the value - if clicking the already selected value, deselect it
    const newValue = currentValue === value ? null : value;
    handleChange({
      target: {
        name: question.tempId,
        value: newValue,
      },
    });
  };

  return (
    <Card
      className={`mt-3 ${
        isMandatory && showError && !hasAnswer ? "border-danger" : ""
      }`}
    >
      <Card.Body>
        <Form.Group className="mb-3">
          <div className="d-flex flex-column">
            <Form.Label>
              <b style={{whiteSpace: 'pre-wrap',wordBreak: 'break-word'}}>
                {question.tempId}.{questionText}
                {isMandatory && <span className="text-danger">*</span>}
              </b>
            </Form.Label>
            {isMandatory && showError && !hasAnswer && (
              <ErrorComponent message={question.requiredErrorText} />
            )}
          </div>
          <div className="boolean-wrapper">
             <div
              className={`oval-shape ${
                currentValue === question.labelTrue ? "selected" : ""
              }`}
              onClick={() => handleLabelClick(question.labelTrue)}
            >
              <span>{question.labelTrue || "Yes"}</span>
            </div>
          
            <div className="pipe"></div>
             <div
              className={`oval-shape ${
                currentValue === question.labelFalse ? "selected" : ""
              }`}
              onClick={() => handleLabelClick(question.labelFalse)}
            >
              <span>{question.labelFalse || "No"}</span>
            </div>
          </div>
        </Form.Group>
      </Card.Body>
    </Card>
  );
}

export default BooleanQuestionCard;
